<template>
    <div class="container">
        <div class="nav_header">
            <h2>我收藏的店铺</h2>
        </div>
        <div class="toolbar">
            <div class="left">
                <el-button @click="on_empty" icon="el-icon-delete">清空我的收藏</el-button>
            </div>
            <div class="right"></div>
        </div>

        <div v-loading="loading">
            <el-table v-loading="loading" :data="data_source" align="center">
                <el-table-column prop="status_text" label="店铺状态" width="80">
                    <div slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.status == 1">{{ scope.row.status_text }}</el-tag>
                        <el-tag type="warning" v-if="scope.row.status == -1">{{ scope.row.status_text }}</el-tag>
                        <el-tag type="danger" v-if="scope.row.status == 0">{{ scope.row.status_text }}</el-tag>
                    </div>
                </el-table-column>

                <el-table-column prop="resource_id" label="店铺编号" width="110"> </el-table-column>
                <el-table-column prop="name" label="店铺名称">
                    <div slot-scope="scope">
                        <a :href="scope.row.release_url" target="_blank">{{ scope.row.title }}</a>
                    </div>
                </el-table-column>

                <el-table-column prop="price" label="价格/元" width="100">
                    <div slot-scope="scope">
                        {{ wan(scope.row.price) }}
                    </div>
                </el-table-column>
            </el-table>
        </div>

        <el-pagination
            style="text-align:center;margin-top:24px;"
            background
            layout="total,prev, pager, next"
            :total="pagination.total"
            :current-page="pagination.current_page"
            :page-size="pagination.per_page"
            @size-change="handle_size_change"
            @current-change="handle_current_change"
        >
        </el-pagination>
    </div>
</template>

<script>
    import moment from "moment";

    export default {
        data() {
            return {
                path: "/buyer/collect",
                data_source: [],
                loading: false,
            };
        },
        created() {
            this.load();
            this.reset_query();
        },
        watch: {
            $route() {
                this.load();
                this.reset_query();
            },
        },
        methods: {
            load() {
                this.loading = true;
                this.$http
                    .get("/resource/collection?" + this.objectToQuery(this.$route.query))
                    .then((response) => {
                        if (response.success) {
                            this.data_source = response.data;
                            this.pagination = response.pagination;
                        }
                    })
                    .catch()
                    .then(() => {
                        this.loading = false;
                    });
            },
            on_empty() {
                this.$confirm("是否要清空您的店铺收藏记录？", "操作确认", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    beforeClose: (action, instance, done) => {
                        if (action === "confirm") {
                            instance.confirmButtonLoading = true;
                            instance.confirmButtonText = "处理中...";

                            this.$http;
                            this.$http
                                .post("/resource/collection/empty")
                                .then((response) => {
                                    if (!response.success) {
                                        instance.callback = () => this.$alert(response.message, "失败");
                                    } else {
                                        this.$message({
                                            type: "success",
                                            message: response.message,
                                        });
                                    }
                                })
                                .catch()
                                .then(() => {
                                    instance.confirmButtonLoading = false;
                                    done();
                                });
                        } else {
                            done();
                        }
                    },
                });
            },
            parse_query() {
                const query = this.$route.query;
                this.dateBetween = query["paid_at"] ? query["paid_at"].split(",") : "";
            },
        },
    };
</script>
